import React from "react";

import { Button, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { connect } from "react-redux";

//Actions
import { removeMacroEvent } from "../../../actions/insights";
import { setAlert } from "../../../actions/alert";

//Utils
import { preventWidows } from "../../../utils/text";

const DeleteHistoryItemConfirm = ({ name, removeMacroEvent, setAlert, macroID }) => {
  const handleDelete = async () => {
    const success = await removeMacroEvent(macroID);

    if (!success) {
      setAlert(
        "An error occurred when trying to delete the history event. Please refresh and try again. If the problem persists, please contact us!",
        "error"
      );
    }
  };
  return (
    <div className="p-4">
      <div>
        {name ? (
          <>
            <Typography variant="h6" className="font-normal leading-snug">
              Delete
            </Typography>
            <Typography variant="h6" className="leading-snug text-secondaryText-600 italic">
              {preventWidows(name)}
            </Typography>
            <Typography variant="h6" className="font-normal leading-snug">
              from your history?
            </Typography>
          </>
        ) : (
          <Typography variant="h6" className="font-normal leading-snug">
            Delete this item from your history?
          </Typography>
        )}
      </div>
      <Button
        variant="contained"
        color="danger"
        className="mt-8 w-full"
        disableElevation
        disableRipple
        onClick={() => handleDelete()}
      >
        Delete {name ? name : "this item"}
      </Button>
    </div>
  );
};

DeleteHistoryItemConfirm.propTypes = {
  name: PropTypes.string,
  removeMacroEvent: PropTypes.func.isRequired,
};

export default connect(null, { removeMacroEvent, setAlert })(DeleteHistoryItemConfirm);
